export const delay = async (ms: number) =>
  await new Promise((resolve) => setTimeout(resolve, ms));

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);

    return true;
  } catch (error) {
    console.log('Unable to copy to clipboard: ', error);
  }

  return false;
};
export const lineChartDefaultColorMap: string[] = [
  '#131AA9',
  '#D8A909',
  '#09D851',
  '#A00611',
  '#8D09D8',
  '#873600',
  '#283747',
];

export const darkThemeLineChartDefaultColorMap: string[] = [
  '#6773E5',
  '#F5D257',
  '#09D851',
  '#E9604F',
  '#4C9CB9',
  '#EC8B33',
  '#406060',
];

export const pastelColorMap: string[] = [
  '#51829B',
  '#7469B6',
  '#FF69B4',
  '#9BB8CD',
  '#88AB8E',
  '#FF7F50',
  '#88AB8E',
  '#AC87C5',
  '#FF4500',
  '#FFD700',
  '#748E63',
  '#D37676',
  '#FFD966',
  '#82A0D8',
  '#EEE8AA',
  '#F7C8E0',
  '#BDB76B',
  '#DA70D6',
  '#BA55D3',
  '#9370DB',
  '#804674',
  '#7286D3',
  '#7F669D',
  '#829460',
  '#F675A8',
  '#554994',
];

export const generateRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
export const truncateTo2dp = (value: string | number): string => {
  if (value === null || value === undefined) return '--';
  const valueToFloat = typeof value === 'string' ? parseFloat(value) : value;
  return isNaN(valueToFloat) ? '--' : valueToFloat.toFixed(2);
};
export const truncateTo3dp = (value: string | number): string => {
  if (value === null || value === undefined) return '--';
  const valueToFloat = typeof value === 'string' ? parseFloat(value) : value;
  return isNaN(valueToFloat) ? '--' : valueToFloat.toFixed(3);
};

export const formatTo2dp = (value: string | number): number => {
  if (value === null) {
    return value;
  }
  const valueToFloat = typeof value === 'string' ? parseFloat(value) : value;
  return isNaN(valueToFloat)
    ? parseFloat('0.00')
    : parseFloat(valueToFloat.toFixed(2));
};

export const getUnixMsBySelectedRange = (dateRange: number) => {
  const d = new Date();
  d.setDate(d.getDate() - dateRange);
  return new Date(d).getTime();
};

export const removeLastItemFromData = (data: any, range: string) => {
  const hourlyRange = ['1Y', 'ALL', 'All', 'Today'];
  const clonedData = JSON.parse(JSON.stringify(data));
  if (hourlyRange.includes(range) && clonedData.length > 0) {
    clonedData[0]?.data?.pop();
  }

  return clonedData;
};

export const moveKeyToBeginningInObject = (
  obj: Record<string, unknown>,
  keyToMove: string
) => {
  if (!(keyToMove in obj)) {
    return obj;
  }
  const newObj = { [keyToMove]: obj[keyToMove] };

  for (const key in obj) {
    if (key !== keyToMove) {
      newObj[key] = obj[key];
    }
  }

  return newObj;
};

export const coordsMap: Record<string, number[]> = {
  // NOTE: use this as default camera placement on all resium maps
  buz: [37.30588, -89.51815],
  klg: [48.46686, -81.33312],
  fmi: [33.44838, -112.07404],
  default: [37.30588, -89.51815],
};

export const underGroundCustomers = ['drn', 'mop', 'tpa'];
export const openPitCustomers = ['buz', 'klg', 'myn', 'alp'];
export const hiddenUploadWorkOrderCustomers = ['drn']; // these customers upload their data on cloud and share it // ex: aws-s3
export const tirePressureCustomers = [
  'gdy',
  'lhl',
  'sav',
  'ncat',
  'buz',
  'drn',
  'alp',
  'myn',
];
export const isTpmsOnlyCustomer = (modules?: {
  isTiresModule: boolean;
  isMachinesModule: boolean;
  isPartsModule: boolean;
}): boolean => {
  if (!modules) return false;
  return (
    modules.isTiresModule && !modules.isMachinesModule && !modules.isPartsModule
  );
};

export const nonGPSCustomers = (customerCode: string): boolean => {
  if (!customerCode) {
    return true;
  }

  const nonGPSCustomersArr = [
    ...underGroundCustomers,
    'ncat',
    'tpa',
    'mlp',
    'gbs',
    'nwt',
  ];
  return nonGPSCustomersArr.includes(customerCode);
};

export const tagSelectionLimitPerCustomer: Record<string, number> = {
  mop: 80,
};
export const defaultTagSelectionLimit: number = 15;

export const getUserId = (
  authUserId: string,
  email: string,
  internalUsersList: any[],
  externalUsersList: any[]
): string => {
  if (authUserId && authUserId.trim() !== '') {
    return authUserId;
  }

  const internalUser = internalUsersList?.find((user) => user.email === email);
  if (internalUser) {
    return internalUser.userId;
  }

  const externalUser = externalUsersList?.find((user) => user.email === email);
  if (externalUser) {
    return externalUser.userId;
  }

  return '';
};
